import React, { useEffect, useCallback } from 'react';
import { Typography, Card, Button } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthAPI } from '../api/authApi';
import styles from './login.module.scss';
import useToast from '../../../shared/hooks/useToast';

const { Title } = Typography;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ChangePassword = () => {
  const query = useQuery();
  const email = query.get('email');
  const navigate = useNavigate();
  const toast = useToast();

  // Odgovor se namerno ne prikazuje (ne otkrivamo da li nalog postoji).
  const handleResend = useCallback(async () => {
    await AuthAPI.forgotPassword({ email });
    toast.success('Poslali smo mejl za reset lozinke na Vašu e-mail adresu.');
  }, [email, toast]);

  useEffect(() => {
    if (!email) {
      navigate('/');
    }
  }, [email, navigate]);

  return (
    <div className={styles.login}>
      <div className={styles.login__left}>
        <div className={styles.login__logo}>
          <Link to="/">
            <img src="/logo.svg" alt="Logo" height={30} width={100} />
          </Link>
        </div>
        <div className={styles.login__formCard}>
          <Card className={styles.login__card}>
            <Title className={styles.login__title} level={1}>
              Promenite šifru
            </Title>
            <p>
              Link za promenu šifre je poslat na <strong>{email}</strong>.
              Molimo vas da proverite vašu email adresu i pratite uputstva za
              promenu šifre.
            </p>
            <p>
              Nije vam stigao email? Pritisnite na dugme ispod{' '}
              <strong>"Pošalji ponovo"</strong> kako biste poslali novi zahtev.
            </p>

            <Button onClick={handleResend} style={{ width: '100%' }}>
              Pošalji ponovo
            </Button>
            <br />
            <br />
            <Button
              type="text"
              onClick={() => window.history.back()}
              style={{ width: '100%' }}
            >
              Odustani
            </Button>
          </Card>
        </div>
      </div>
      <div className={styles.login__right}></div>
    </div>
  );
};

export default ChangePassword;
